import { FC, ReactNode } from 'react';
import { createPortal } from 'react-dom';

import IconCross from '../icons/cross.svg';
import styles from './modal.module.css';

type Props = {
    title: string
    description?: string
    isOpen: boolean
    buttons?: ReactNode
    onClose: () => void
};

export const Modal: FC<Props> = ({ title, description, buttons, isOpen, onClose, children }) => {
    return isOpen ? createPortal(
        <div className={styles['modal__container']}>
            <button type="button" className={styles['modal__overlay']} onClick={onClose} aria-hidden />
            <div className={styles['modal__body']}>
                <button type="button" className={styles['modal__close']} onClick={onClose}>
                    <IconCross />
                </button>

                <h2 className={styles['modal__title']}>{title}</h2>
                <p className={styles['modal__description']}>
                    {description}
                </p>

                {children}

                {!!buttons && (
                    <div className={styles['modal__buttons']}>
                        {buttons}
                    </div>
                )}
            </div>
        </div>,
        document.getElementById('account-container')!
    ) : null;
};
